import React from 'react'
import PropTypes from 'prop-types'
import resolveProps from '../../utils/resolveProps'

const config = {
  types: [
    {
      title: 'simple',
      isDefault: true
    }
  ],
  modifiers: ['simpleLight'],
  states: []
}

export default function Header(props) {
  const {
    brandSrc,
    brandHref,
    brandAlt,
    simpleLight,
    children,
    ...rest
  } = props

  return (
    <header
      {...rest}
      className={resolveProps(props, config, 'Header')}
      role="banner"
    >
      <div className="mdn-Container">
        <div className="mdn-Header--simple-content">
          <a href={brandHref || '/'}>
            <img
              className="mdn-logoSvg"
              src={
                brandSrc ||
                (simpleLight
                  ? 'https://mondrian.claro.com.br/brands/horizontal/default/claro.svg'
                  : 'https://mondrian.claro.com.br/brands/horizontal/inverse/claro.svg')
              }
              alt={brandAlt || 'Logotipo da Claro'}
            />
          </a>
          <div>{children}</div>
        </div>
      </div>
    </header>
  )
}

Header.propTypes = {
  etc: PropTypes.object,
  inverse: PropTypes.bool,
  brandSrc: PropTypes.string,
  brandAlt: PropTypes.string,
  children: PropTypes.node,
  brandHref: PropTypes.string,
  simpleLight: PropTypes.bool
}
